<script>
  let _uid = 0;
  //import CustomButton from '@/app/components/button/CustomButton';

  export default {
    props: {
      title: {
        type: String,
        default: "Modal Title",
      },
      subTitle: {
        type: String,
      },
      btnType: {
        type: String,
        default: "submit",
      },
      btnTextSubmit: {
        type: String,
        default: "Submit",
      },
      btnTextClose: {
        type: String,
        default: "Cancel",
      },
      btnColorSubmit: {
        type: String,
        default: "bg-primary",
      },
      backdrop: {
        type: Boolean,
        default: true,
      },
      width: {
        type: String,
        default: "max-w-lg",
      },
      btnColor: {
        type: String,
        default: "bg-primary",
      },
      btnText: {
        type: String,
        default: "Show Modal",
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      variant: {
        type: String,
      }
    },
    data() {
      _uid += 1;
      return {
        id: `modal-num-${_uid}`,
      };
    },
    components: {
      //CustomButton
    }
  };
</script>

<template>
  <section>
    <teleport to="body">
      <transition name="slide-up">
        <div
          :class="{
            'bg-gray-800 bg-opacity-50': backdrop,
            'bg-transparent': !backdrop,
          }"
          class="modal-overlay p-5 overflow-y-scroll"
          @click.self="$emit('cancel')"
          v-if="isOpen"
        >
          <div
            :class="width"
            class="container mx-auto w-full pt-10"
          >
            <form @submit.prevent="$emit('submitForm')">
              <div
                class="modal bg-white border dark:border-gray-600 dark:bg-gray-800 w-full shadow rounded-md overflow-auto"
              >
                <div class="modal-head px-5 py-4 border-b">
                  <div class="heading flex items-center justify-between">
                    <div>
                      <h2 class="dark:text-white">{{ title }}</h2>
                      <p class="subtitle">{{ subTitle }}</p>
                    </div>
                    <div>
                      <button
                        class="text-xs text-gray-700"
                        @click="$emit('cancel')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-width="2"
                            d="M6 18L18 6m0 12L6 6"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="modal-body dark:text-white">
                  <slot name="body" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </transition>
    </teleport>
  </section>
</template>

<style lang="scss">
  .heading {
    @apply text-lg font-semibold text-gray-800;
  }
  .heading .subtitle {
    @apply text-xs font-normal text-gray-400;
  }
  .modal-overlay {
    @apply w-full h-screen fixed top-0 inset-0;
  }
  .modal-body {
    @apply p-4;
  }
  .modal-footer {
    @apply p-4 bg-gray-50;
  }
  /*
  Enter and leave animations can use different
  durations and timing functions.
*/
  .slide-up-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-up-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-up-enter-from,
  .slide-up-leave-to {
    transform: translateY(-20px);
    opacity: 0;
  }
</style>